import { productVariantsContracts } from "./product-variants.contract";
import { warehousesContracts } from "./warehouses.contract";
import { supplyNetworkContracts } from "./supply-network.contract";
import { itemGroupsContracts } from "./item-groups.contract";
import { productsContracts } from "./products.contract";
import { productMarginsContracts } from "./product-margins.contract";
import { productCatalogContracts } from "./product-catalog.contract";
import { transferOrdersContracts } from "./transfer-orders.contract";
import { pricelistContracts } from "./pricelist.contract";
import { pricelistCasesContracts } from "./pricelist-cases.contract";
import { metadataChangeSetsContracts } from "./metadata-change-sets.contract";
import { changeSetCommentsContracts } from "./change-set-comments.contract";
import { itemListsContracts } from "./item-lists.contract";
import { validationRulesContracts } from "./validation-rules.contract";
import { as400PublishContracts } from "./as400-publish.contract";
import { as400ImportContracts } from "./as400-import.contract";

export const inventoryManagementContracts = {
  productVariants: productVariantsContracts,
  warehouses: warehousesContracts,
  supplyNetwork: supplyNetworkContracts,
  itemGroups: itemGroupsContracts,
  products: productsContracts,
  productMargins: productMarginsContracts,
  productCatalog: productCatalogContracts,
  transferOrders: transferOrdersContracts,
  pricelist: pricelistContracts,
  pricelistCases: pricelistCasesContracts,
  metadataChangeSets: metadataChangeSetsContracts,
  changeSetComments: changeSetCommentsContracts,
  itemLists: itemListsContracts,
  validationRules: validationRulesContracts,
  as400Publish: as400PublishContracts,
  as400Import: as400ImportContracts,
} as const;

export * from "./product-variants.contract";
export * from "./warehouses.contract";
export * from "./supply-network.contract";
export * from "./item-groups.contract";
export * from "./products.contract";
export * from "./product-margins.contract";
export * from "./product-catalog.contract";
export * from "./transfer-orders.contract";
export * from "./pricelist.contract";
export * from "./pricelist-cases.contract";
export * from "./pricelist-case-filters.contract";
export * from "./metadata-change-sets.contract";
export * from "./change-set-comments.contract";
export * from "./change-set-review.contract";
export * from "./item-lists.contract";
export * from "./validation-rules.contract";
export * from "./as400-publish.contract";
export * from "./as400ItemNumber";
export * from "./as400-import.contract";
export * from "./rd-branch-correspondence";
